import React from 'react';
import { motion } from 'framer-motion';
import { Section } from '../components/ui/Section';
export function TermsPage() {
  const sections = [{
    number: '1',
    title: 'Introduction',
    content: <p data-id="element-415">
          Welcome to Belo Digital. By accessing or using our website, products,
          or services, you agree to be bound by these Terms & Conditions. If you
          do not agree, please refrain from using our services.
        </p>
  }, {
    number: '2',
    title: 'Services',
    content: <>
          <p className="mb-4" data-id="element-416">
            Belo Digital provides digital solutions including but not limited
            to:
          </p>
          <ul className="space-y-2" data-id="element-417">
            <li className="flex items-start" data-id="element-418">
              <span className="w-2 h-2 rounded-full bg-[#FF6600] mt-2 mr-3 shrink-0" data-id="element-419" />
              Software & digital systems development
            </li>
            <li className="flex items-start" data-id="element-420">
              <span className="w-2 h-2 rounded-full bg-[#FF6600] mt-2 mr-3 shrink-0" data-id="element-421" />
              IT consulting & advisory
            </li>
            <li className="flex items-start" data-id="element-422">
              <span className="w-2 h-2 rounded-full bg-[#FF6600] mt-2 mr-3 shrink-0" data-id="element-423" />
              Digital infrastructure & integrations
            </li>
            <li className="flex items-start" data-id="element-424">
              <span className="w-2 h-2 rounded-full bg-[#FF6600] mt-2 mr-3 shrink-0" data-id="element-425" />
              Data & technology solutions
            </li>
          </ul>
          <p className="mt-4" data-id="element-426">
            Specific service details may be governed by separate agreements or
            contracts.
          </p>
        </>
  }, {
    number: '3',
    title: 'Use of Website',
    content: <>
          <p className="mb-4" data-id="element-427">
            You agree to use our website lawfully and not to:
          </p>
          <ul className="space-y-2" data-id="element-428">
            <li className="flex items-start" data-id="element-429">
              <span className="w-2 h-2 rounded-full bg-[#FF6600] mt-2 mr-3 shrink-0" data-id="element-430" />
              Engage in fraudulent or harmful activities
            </li>
            <li className="flex items-start" data-id="element-431">
              <span className="w-2 h-2 rounded-full bg-[#FF6600] mt-2 mr-3 shrink-0" data-id="element-432" />
              Attempt unauthorized access to systems
            </li>
            <li className="flex items-start" data-id="element-433">
              <span className="w-2 h-2 rounded-full bg-[#FF6600] mt-2 mr-3 shrink-0" data-id="element-434" />
              Distribute malicious software or code
            </li>
            <li className="flex items-start" data-id="element-435">
              <span className="w-2 h-2 rounded-full bg-[#FF6600] mt-2 mr-3 shrink-0" data-id="element-436" />
              Violate applicable laws or regulations
            </li>
          </ul>
        </>
  }, {
    number: '4',
    title: 'Intellectual Property',
    content: <p data-id="element-437">
          All content, designs, software, trademarks, and materials on this
          website belong to Belo Digital unless stated otherwise. Unauthorized
          reproduction or use is prohibited.
        </p>
  }, {
    number: '5',
    title: 'Client Responsibilities',
    content: <>
          <p className="mb-4" data-id="element-438">Clients agree to:</p>
          <ul className="space-y-2" data-id="element-439">
            <li className="flex items-start" data-id="element-440">
              <span className="w-2 h-2 rounded-full bg-[#FF6600] mt-2 mr-3 shrink-0" data-id="element-441" />
              Provide accurate and lawful information
            </li>
            <li className="flex items-start" data-id="element-442">
              <span className="w-2 h-2 rounded-full bg-[#FF6600] mt-2 mr-3 shrink-0" data-id="element-443" />
              Maintain confidentiality of credentials
            </li>
            <li className="flex items-start" data-id="element-444">
              <span className="w-2 h-2 rounded-full bg-[#FF6600] mt-2 mr-3 shrink-0" data-id="element-445" />
              Use delivered solutions responsibly
            </li>
            <li className="flex items-start" data-id="element-446">
              <span className="w-2 h-2 rounded-full bg-[#FF6600] mt-2 mr-3 shrink-0" data-id="element-447" />
              Comply with applicable laws
            </li>
          </ul>
        </>
  }, {
    number: '6',
    title: 'Limitation of Liability',
    content: <p data-id="element-448">
          Belo Digital shall not be liable for indirect, incidental, or
          consequential damages arising from use of our website or services,
          except where required by law.
        </p>
  }, {
    number: '7',
    title: 'Confidentiality',
    content: <p data-id="element-449">
          We respect confidentiality of client information. Both parties may be
          bound by separate Non-Disclosure Agreements where applicable.
        </p>
  }, {
    number: '8',
    title: 'Termination',
    content: <p data-id="element-450">
          We reserve the right to suspend or terminate access to services where
          misuse, unlawful activity, or breach of terms occurs.
        </p>
  }, {
    number: '9',
    title: 'Governing Law',
    content: <p data-id="element-451">These Terms are governed by the laws of the Republic of Kenya.</p>
  }, {
    number: '10',
    title: 'Changes to Terms',
    content: <p data-id="element-452">
          We may update these Terms from time to time. Continued use of services
          constitutes acceptance of revised Terms.
        </p>
  }, {
    number: '11',
    title: 'Contact Information',
    content: <div className="space-y-2" data-id="element-453">
          <p data-id="element-454">For questions regarding these Terms:</p>
          <p className="font-semibold text-[#0C0C0C]" data-id="element-455">Belo Digital</p>
          <p data-id="element-456">
            Email:{' '}
            <a href="mailto:biz@belo.co.ke" className="text-[#00316B] hover:text-[#FF6600] transition-colors" data-id="element-457">
              biz@belo.co.ke
            </a>
          </p>
          <p data-id="element-458">
            Phone:{' '}
            <a href="tel:+254735977519" className="text-[#00316B] hover:text-[#FF6600] transition-colors" data-id="element-459">
              +254 735 977 519
            </a>
          </p>
        </div>
  }];
  return <main className="pt-24" data-id="element-460">
      <Section background="default" data-id="element-461">
        <div className="max-w-4xl" data-id="element-462">
          <motion.p initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-sm font-semibold text-[#FF6600] uppercase tracking-wider mb-4" data-id="element-463">
            Legal
          </motion.p>
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.05
        }} className="text-4xl md:text-5xl font-bold font-heading text-[#0C0C0C] mb-4 leading-tight" data-id="element-464">
            Terms & Conditions
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-gray-500 text-sm" data-id="element-465">
            Last updated:{' '}
            {new Date().toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
          })}
          </motion.p>
        </div>
      </Section>

      <Section background="white" data-id="element-466">
        <div className="max-w-3xl mx-auto" data-id="element-467">
          <div className="space-y-12" data-id="element-468">
            {sections.map((section, index) => <motion.div key={section.number} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.04
          }} className="border-b border-gray-100 pb-12 last:border-0" data-id="element-469">
                <div className="flex items-start gap-4 mb-4" data-id="element-470">
                  <span className="text-xs font-bold text-[#FF6600] bg-[#FF6600]/10 px-2 py-1 rounded mt-1 shrink-0" data-id="element-471">
                    {section.number.padStart(2, '0')}
                  </span>
                  <h2 className="text-xl font-bold font-heading text-[#0C0C0C]" data-id="element-472">
                    {section.title}
                  </h2>
                </div>
                <div className="ml-10 text-gray-600 leading-relaxed text-[15px]" data-id="element-473">
                  {section.content}
                </div>
              </motion.div>)}
          </div>
        </div>
      </Section>
    </main>;
}